import React from 'react';
import ShareListItem from './components/ShareListItem';
import PropTypes from 'prop-types';
import './styles.css';

const ShareList = ({ data, actions }) => {
  const { isSelected } = actions;
  return (
    <div className="share-list">
      <div className="share-list__members">
        {data.map(item => {
          return (
            <ShareListItem
              key={item.RecruiterID}
              data={item}
              actions={actions}
              selected={isSelected(item.RecruiterID)}
            />
          );
        })}
      </div>
    </div>
  );
};

ShareList.propTypes = {
  data: PropTypes.array,
  actions: PropTypes.object,
};

export default ShareList;
